import { render, staticRenderFns } from "./InputTickets.vue?vue&type=template&id=0bb8e02d&scoped=true"
import script from "./InputTickets.vue?vue&type=script&lang=js"
export * from "./InputTickets.vue?vue&type=script&lang=js"
import style0 from "./InputTickets.vue?vue&type=style&index=0&id=0bb8e02d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8e02d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb8e02d')) {
      api.createRecord('0bb8e02d', component.options)
    } else {
      api.reload('0bb8e02d', component.options)
    }
    module.hot.accept("./InputTickets.vue?vue&type=template&id=0bb8e02d&scoped=true", function () {
      api.rerender('0bb8e02d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components/InputTickets.vue"
export default component.exports